<template>
  <div>
    <v-snackbar v-model="showsnackbar" color="red" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex px-2 xs12 sm12 md12 lg12 xl12 text-center>
        <v-form ref="form" lazy-validation>
          <v-layout wrap>
            <v-flex xs12 pt-2>
              <v-card class="mb-1">
                <v-card-title> Customers </v-card-title>
              </v-card>
              <v-card class="mb-4">
                <v-card-text>
                  <v-layout wrap style="align-items: center" justify-center>
                    <v-flex xs6 sm6 md6></v-flex>
                    <v-flex xs6 sm6 md6>
                      <v-layout wrap justify-center>
                        <v-flex xs6 sm6 md4 text-right pt-2
                          >Items Per Page</v-flex
                        >
                        <v-flex xs6 sm6 md2>
                          <v-select
                            solo
                            flat
                            v-model="itemsPerPage"
                            :items="ItemsCount"
                            dense
                            required
                          ></v-select>
                        </v-flex>
                        <v-flex
                          xs6
                          sm6
                          md2
                          text-center
                          pt-2
                          style="color: black"
                        >
                          {{ pageStart }}-{{ pageEnd }} of {{ count }}
                        </v-flex>
                        <v-flex xs2 sm2 md1 pt-2 text-right>
                          <span v-if="page > 1">
                            <v-icon @click="prevpage" color="primary"
                              >mdi-chevron-left</v-icon
                            >
                          </span>
                          <span v-else>
                            <v-icon disabled color="primary"
                              >mdi-chevron-left</v-icon
                            >
                          </span>
                        </v-flex>
                        <v-flex xs2 sm2 md1 pt-2 text-center>
                          <!-- <v-text-field
                              v-model="page"
                              color="#26af82"
                              min="1"
                              :dense="true"
                              :max="totalpages"
                              type="number"
                              class="centered-input"
                            ></v-text-field> -->
                          {{ page }}
                        </v-flex>
                        <v-flex xs2 sm2 md1 pt-2 text-left>
                          <span v-if="page < totalpages">
                            <v-icon @click="nextpage" color="primary"
                              >mdi-chevron-right</v-icon
                            >
                          </span>
                          <span v-else>
                            <v-icon disabled color="primary"
                              >mdi-chevron-right</v-icon
                            >
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-data-table
                  bordered
                  :headers="headers"
                  :items="customers"
                  hide-default-footer
                  :items-per-page="itemsPerPage"
                  class="row-pointer tablewid pb-12"
                  @click:row="rowClicked"
                >
                  <!-- @click:row="rowClicked" -->
                  <template v-slot:[`item.fullname`]="{ item }">
                    <span v-if="item.customerid">
                      {{ item.customerid.firstName }}
                      {{ item.customerid.lastName }}
                    </span>
                  </template>
                  <template v-slot:[`item.email`]="{ item }">
                    <span v-if="item.customerid">
                      {{ item.customerid.email }}
                    </span>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <span :key="item.status">
                      <v-dialog v-model="item.deleteCustomer" max-width="600px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            text
                            v-on="on"
                            v-bind="attrs"
                            color="red"
                            @click="deleteConfirmation(item)"
                          >
                            Reject
                          </v-btn>
                        </template>
                        <v-card>
                          <v-card-title class="headline grey lighten-2">
                            Delete Confirmation
                          </v-card-title>

                          <v-card-text>
                            <span style="font-size: 16px; font-weight: 600"
                              >Please confirm that you want to Remove this User?
                            </span>
                          </v-card-text>
                          <v-divider></v-divider>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="primary"
                              @click="item.deleteCustomer = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              color="error"
                              class="mr-4"
                              @click="rejectSeller(item)"
                            >
                              Delete
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </span>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
// import pdf from 'vue-pdf'
export default {
  // components: {
  //   pdf
  // },
  data() {
    return {
      headers: [
        { text: "Full Name", value: "fullname", sortable: true },
        { text: "Phone", value: "phone" },
        { text: "Email", value: "email" },
        { text: "Role", value: "role" },
        { text: "Actions", value: "actions", sortable: false, align: "center" },
      ],
      showsnackbar: false,
      msg: null,
      timeout: 5000,
      deleteCustomer: false,
      mini: true,
      customers: [],
      pageStart: 0,
      pageEnd: 0,
      count: 0,
      itemsPerPage: 25,
      page: 1,
      totalpages: 0,
      ItemsCount: [25, 50, 100],
    };
  },
  beforeMount() {
    this.getCustomers();
  },
  watch: {
    itemsPerPage: function () {
      this.getCustomers();
    },
  },
  methods: {
    prevpage() {
      if (this.page > 1) {
        // if (this.searchKey || this.company || this.address || this.phone || this.email || this.nature || this. customerID) {
        this.page--;
        this.getCustomers();
        // } else {
        //   this.page--;
        //   this.getCustomers();
        // }
      }
    },
    nextpage() {
      if (this.page < this.totalpages) {
        // if (this.searchKey || this.company || this.address || this.phone || this.email || this.nature || this. customerID) {
        this.page++;
        this.getCustomers();
        // } else {
        //   this.page++;
        //   this.getCustomers();
        // }
      }
    },
    getCustomers() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/users/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          role: "customer",
          status: "Active",
          limit: this.itemsPerPage,
          page: this.page,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.customers = response.data.data;
          this.count = response.data.totalLength;
          this.totalpages = Math.ceil(
            response.data.totalLength / this.itemsPerPage
          );

          if (response.data.length > 0) {
            this.pageStart = (response.data.page - 1) * response.data.limit + 1;
            this.pageEnd = this.pageStart + response.data.length - 1;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = err.response.data.msg;
          this.msg = "Server Unreachable";
          this.showsnackbar = true;
        });
    },
    deleteConfirmation() {
      this.deleteCustomer = true;
    },
    rejectSeller(item) {
      item.deleteCustomer = false;

      axios({
        url: "/user/reject",
        method: "POST",
        data: {
          id: item._id,
        },
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "User Deleted";
            this.showsnackbar = true;

            this.getCustomers();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    rowClicked(item) {
      this.$router.push("/User/" + item._id);
    },
  },
};
</script>
<style >
tbody tr:nth-of-type(odd) {
  background-color: rgba(28, 133, 219, 0.05);
}
.row-pointer > .v-data-table__wrapper > table > tbody > tr :hover {
  cursor: pointer;
}
</style>



